var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.768,
    height: 39.225,
    viewBox: "0 0 34.768 39.225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2910",
    "data-name": "Group 2910",
    transform: "translate(-5127.441 -627)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15564",
    "data-name": "Path 15564",
    d: "M178.577,59.417,171.23,52.07a1.874,1.874,0,0,0-1.333-.554H148.989a1.5,1.5,0,0,0-1.5,1.506v32.61a1.507,1.507,0,0,0,1.5,1.506h18.9c-.066-.155-.127-.31-.183-.469s-.1-.31-.15-.469a8.125,8.125,0,0,1-.314-2.262,8.345,8.345,0,0,1,.286-2.163H152.794v-5.02l4.021-3.984,3.542,3.519,8.8-8.756,4.659,4.612v3.74a8.205,8.205,0,0,1,4.368.3c.16.056.314.117.469.183s.314.141.469.216V60.75a1.846,1.846,0,0,0-.544-1.333ZM157.66,67.553a2.787,2.787,0,1,1,2.787-2.787A2.79,2.79,0,0,1,157.66,67.553Zm14.372-8.375a.565.565,0,0,1-.563-.563V55.049l4.129,4.129Z",
    transform: "translate(4979.953 575.484)",
    fill: "#adadad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15565",
    "data-name": "Path 15565",
    d: "M404.61,351.131q-.246-.155-.507-.3a6.816,6.816,0,0,0-4.8-.587c-.15.038-.3.08-.446.127l-.023.009c-.16.052-.314.108-.469.174a6.821,6.821,0,0,0-3.486,3.2c-.08.155-.15.31-.216.469l-.014.028c-.061.145-.117.291-.164.441a6.809,6.809,0,0,0,.206,4.861c.075.174.155.338.239.5a6.8,6.8,0,1,0,9.68-8.929Zm-.042,6.428H401.64v2.928h-1.408v-2.928H397.3v-1.408h2.928v-2.928h1.408v2.928h2.928Z",
    transform: "translate(4754.469 302.561)",
    fill: "#ff6036"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.b3aecc52d68e944fcbc784f8f06617b3.svg";
export { ForwardRef as ReactComponent };